<div>
  <h3>Vehicle Aging Report</h3>

  <a #donwloadCsvLink></a>
  <button mat-raised-button type="button" (click)="runReport()">Run Aging Report</button>
</div>